import React, { useEffect, useState } from 'react'
import { API_URL } from '../../Config';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import Cookies from 'js-cookie';
import { CSVLink } from 'react-csv';
import './filterTrans.css'

function FilterTrans({ onTransactionsUpdate }) {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [transactions, setTransactions] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [updatecName, setUpdatecName] = useState('');
    const [updateAmount, setUpdateAmount] = useState('');
    const [updateType, setUpdateType] = useState('');
    const [updateAccount, setUpdateAccount] = useState('');
    const [showEditForm, setShowEditForm] = useState(false);
    const [cashData, setCashData] = useState({ amount: 0, limit1: 0, limit2: 0 });    
  
    useEffect(() => {
        fetch(`${API_URL}/cashdata`)
          .then(res => res.json())
          .then(data => {
            setCashData(data[0]);
          })
          .catch(err => console.log(err));
      }, []);

    const handleSubmit = async (event) => {
      event.preventDefault();
      if (!startDate || !endDate) {
        alert('Please select start and end dates.');
        return;
      }
  
      try {
        const response = await fetch(`${API_URL}/data/filter?startDate=${startDate}&endDate=${endDate}`);
        const result = await response.json();
        onTransactionsUpdate(result.data);
        setTransactions(result.data);
      } catch (error) {
        console.error(error);
        alert('An error occurred while fetching data.');
      }
    };

    const handleDeleteClick = async (_id) => {
      try {
        await fetch(`${API_URL}/delete/data/${_id}`, {
          method: 'DELETE',
        });
      } catch (error) {
        console.error(error);
      }
      fetch(`${API_URL}/data/filter?startDate=${startDate}&endDate=${endDate}`)
      .then(res => res.json())
      .then(data => {
          setTransactions(data.data)
      })
      .catch(err => console.log(err));
      fetch(`${API_URL}/cashdata`)
      .then(res => res.json())
      .then(data => setCashData(data[0]))
      .catch(err => console.log(err));  
    };

    const UpdatehandlecNameChange = (event) => {
        setUpdatecName(event.target.value);
      };
    
      const UpdatehandleAmountChange = (event) => {
        setUpdateAmount(event.target.value);
      };
    
      const UpdatehandleTypeChange = (event) => {
        setUpdateType(event.target.value);
      };
    
      const UpdatehandleAccountChange = (event) => {
        setUpdateAccount(event.target.value);
      };  
  
      const handleEditClick = (transaction) => {
        setSelectedRowId(transaction._id);
        setUpdatecName(transaction.cName);
        setUpdateAmount(transaction.amount);
        setUpdateType(transaction.type);
        setUpdateAccount(transaction.account);
        setShowEditForm(true);
      }
    
      const handlePopupClose=()=>{
        setShowEditForm(false);
      }
      const handleUpdateClick = async () => {
        try {
          const response = await fetch(`${API_URL}/update/data/${selectedRowId}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              cName: updatecName,
              type: updateType,
              account: updateAccount,
              amount: updateAmount
            })
          });
          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message);
          }
          setShowEditForm(false);
        } catch (error) {
          console.error(error);
        }
        fetch(`${API_URL}/data/filter?startDate=${startDate}&endDate=${endDate}`)
        .then(res => res.json())
        .then(data => setTransactions(data.data))
        .catch(err => console.log(err));
        fetch(`${API_URL}/cashdata`)
        .then(res => res.json())
        .then(data => setCashData(data[0]))
        .catch(err => console.log(err));  
      };

      const headers = [
        { label: 'Name', key: 'cName' },
        { label: 'Amount', key: 'amount' },
        {
          label: 'Type',
          key: 'type',
          formatter: (value) => {
            return value === 1 ? 'Debit' : 'Deposit';
          },
        },
        { label: 'Account', key: 'account' },
        { label: 'Through', key: 'through' },
        { label: 'Date', key: 'date' },
        { label: 'Time', key: 'time' },
      ];
      
      const data = transactions.map(({ cName, amount, type, account, through, createdAt }) => ({
        cName,
        amount,
        type: type === 1 ? 'Debit' : 'Deposit',
        account,
        through,
        date: new Date(createdAt).toLocaleDateString(),
        time: new Date(createdAt).toLocaleTimeString(),
      }));
      
      
  return (
    <div className='filter-trans'>
    <div className="home-cash-limit">
        <div className="home-cash">
            <p>Total cash:</p>
            <p>{cashData.amount}</p>
        </div>
        <div className="home-cash">
            <p>Account1 limit:</p>
            <p>{cashData.limit1}</p>
        </div>
        <div className="home-cash">
            <p>Account2 limit:</p>
            <p>{cashData.limit2}</p>
        </div>
        </div>
    <form className='filter-date' onSubmit={handleSubmit}>
      <div className="start-date">
        <label htmlFor="startDate">Start Date:</label>
        <input type="date" id="startDate" name="startDate" value={startDate} onChange={(event) => setStartDate(event.target.value)} />
      </div>
      <div className="end-date">
        <label htmlFor="endDate">End Date:</label>
        <input type="date" id="endDate" name="endDate" value={endDate} onChange={(event) => setEndDate(event.target.value)} />
      </div>
      <div className="filter-button">
        <button type="submit">Filter Data</button>
      </div>
    </form>
    <div className='transactions'>
        <div className="transactions-container">
            {transactions.map((transaction, index) => (
            <div key={index} className="transaction-card">
                <div className="transaction-top-card">
                <div className="transaction-details">
                    <p className={transaction.type === 1 ? 'green' : 'red'}>Made by {transaction.through} for {transaction.cName}</p>
                    <p className={transaction.type === 1 ? 'green' : 'red'}>to {transaction.type === 1 ? 'Debit' : 'Deposit'} amount from account {transaction.account}</p>
                </div>
                <div className="transaction-amount">
                    <p className={transaction.type === 1 ? 'green' : 'red'}>
                        {transaction.type === 1 ? '+' : '-'}{transaction.amount}
                    </p>
                </div>
                </div>
                {Cookies.get('type') === '0' &&
                <>
                <div className="transaction-bot-card">
                    <div className="transaction-button">
                    <DeleteIcon onClick={() => handleDeleteClick(transaction._id)}/>
                    </div>
                    <div className="transaction-button">
                    <EditIcon onClick={() => handleEditClick(transaction)}/>
                    </div>
                </div>
                </>
                }
            </div>
            ))}
            {transactions.length > 0 && (
              <CSVLink data={data} headers={headers} filename={"filtered-transactions.csv"} className="btn btn-primary">
                Export to Excel
              </CSVLink>
            )}
        </div>
        {showEditForm && (
            <div className="data-popup">
            <div className="data-popup-container">
            <CloseIcon onClick={handlePopupClose}/>
                <div className="data-update-form">
                <input type="text" name='cName' value={updatecName} onChange={UpdatehandlecNameChange}/>
                <input type="number" name='amount' value={updateAmount} onChange={UpdatehandleAmountChange}/>
                <select name="type" value={updateType} onChange={UpdatehandleTypeChange}>
                    <option value="" disabled defaultValue>--Debit/Deposit--</option>
                    <option value="1">Debit</option>
                    <option value="2">Deposit</option>
                </select>
                <select name="account" value={updateAccount} onChange={UpdatehandleAccountChange}>
                    <option value="" disabled defaultValue>--Select Account--</option>
                    <option value="1">Account 1</option>
                    <option value="2">Account 2</option>
                </select>
                <button onClick={handleUpdateClick}>Update</button>
                </div>
            </div>
            </div>
            )}
        </div>
        </div>
  )
}

export default FilterTrans